window.blockElement = function(elementID) {

	var theBlockUI = KTBlockUI.getInstance(document.querySelector(elementID));
	if(!theBlockUI) {
		theBlockUI = new KTBlockUI(document.querySelector(elementID));
	}
	theBlockUI.options.message = '<span class="spinner-border text-primary"></span>';
	theBlockUI.block();
}

window.blockElementWithMsg = function(elementID, msg) {
	var theBlockUI = KTBlockUI.getInstance(document.querySelector(elementID));
	if(!theBlockUI) {
		theBlockUI = new KTBlockUI(document.querySelector(elementID));
	}
	theBlockUI.options.message = '<div class="blockui-message">' + msg + '</div>';
	theBlockUI.block();
}

window.releaseElement = function(elementID) {
	var theBlockUI = KTBlockUI.getInstance(document.querySelector(elementID));
	if(theBlockUI && theBlockUI.isBlocked()) {
		theBlockUI.release();
	}
}

$( document ).ready(function() {

	window.reloadMenus = function() {
		var i = 0;
		var interval = setInterval(function() {
			KTMenu.createInstances();
			i++;
			if(i == 10) {
				clearInterval(interval);
			}
		}, 500);

		KTMenu.createInstances();
	}

	$('#kt_modal_create_deal').on('shown.bs.modal', function (e) {

		$('#create_deal_loan_amount').on('input', function(event) {
			// Get the current input value
			var inputValue = $(this).val();
	
			// Replace any non-numeric characters except for a single decimal point
			var sanitizedValue = inputValue.replace(/[^0-9.]/g, '');
	
			// Allow only one decimal point
			if (sanitizedValue.indexOf('.') !== sanitizedValue.lastIndexOf('.')) {
				sanitizedValue = sanitizedValue.slice(0, sanitizedValue.lastIndexOf('.'));
			}
	
			// Limit to two decimal places
			var decimalIndex = sanitizedValue.indexOf('.');
			if (decimalIndex !== -1) {
				sanitizedValue = sanitizedValue.slice(0, decimalIndex + 3);
			}
	
			// Split the integer and decimal parts
			var parts = sanitizedValue.split('.');
			var integerPart = parts[0];
			var decimalPart = parts[1] || '';
	
			// Format the integer part with commas
			var formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	
			// Concatenate the formatted integer part and decimal part
			var formattedValue = formattedIntegerPart + (decimalIndex !== -1 ? '.' + decimalPart : '');
	
			// Set the input value to the formatted value
			$(this).val(formattedValue);
		});

		$('#portfolio_property_loan_amount').on('input', function(event) {
			// Get the current input value
			var inputValue = $(this).val();
	
			// Replace any non-numeric characters except for a single decimal point
			var sanitizedValue = inputValue.replace(/[^0-9.]/g, '');
	
			// Allow only one decimal point
			if (sanitizedValue.indexOf('.') !== sanitizedValue.lastIndexOf('.')) {
				sanitizedValue = sanitizedValue.slice(0, sanitizedValue.lastIndexOf('.'));
			}
	
			// Limit to two decimal places
			var decimalIndex = sanitizedValue.indexOf('.');
			if (decimalIndex !== -1) {
				sanitizedValue = sanitizedValue.slice(0, decimalIndex + 3);
			}
	
			// Split the integer and decimal parts
			var parts = sanitizedValue.split('.');
			var integerPart = parts[0];
			var decimalPart = parts[1] || '';
	
			// Format the integer part with commas
			var formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	
			// Concatenate the formatted integer part and decimal part
			var formattedValue = formattedIntegerPart + (decimalIndex !== -1 ? '.' + decimalPart : '');
	
			// Set the input value to the formatted value
			$(this).val(formattedValue);
		});

		

		window.initDealAutocomplete();
	});


  	function onPageChange() {
		$('a').each(function() {

			if (!$(this).attr('on-click-set')) {
				$(this).attr('on-click-set', 'true');

				var href = $(this).attr('href');

				if(!href) {
					return;
				}

				var pattern = /\/deals\/([^/]+)\/id\/(\d+)/;
				var match = href.match(pattern);
				if (match) {

					$(this).on('click', function(event) {

						event.preventDefault();

						var dealID = match[2];
						var csrf_token = $('meta[name="csrf-token"]').attr('content');
						$.ajax({
							type: "POST",
							url: "/deals/checkaccess/id/" + dealID,
							data: { 
								_token: csrf_token,
							},
							success: function (data) {
								if(data != "yes") {
									$("#request_access_deal_users").html(data);
									KTApp.initBootstrapTooltips();
									$("#kt_modal_request_access").modal('show');
								} else {
									window.location.href = href;
								}
							}
						});
					});
				}
			}
		});
  	}

    var observer = new MutationObserver(function(mutationsList, observer) {
        mutationsList.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                onPageChange();
            }
        });
    });

    var targetNode = document.body;

    var config = {
        childList: true,
        subtree: true
    };

    observer.observe(targetNode, config);

    $(window).on('unload', function() {
        observer.disconnect();
    });

	$("#kt_modal_request_access_cancel").on("click", function() {
		$("#kt_modal_request_access").modal('hide');
	});

	$("#kt_modal_request_access_submit").on("click", function() {
		var csrf_token = $('meta[name="csrf-token"]').attr('content');
	});

	
	window.comingSoon = function() {
		Swal.fire({
			title: "Coming Soon",
			icon: "warning",
			confirmButtonText: "OK",
			customClass: {
				confirmButton: 'btn-darkblue',
				timerProgressBar: 'bg-darkblue',
			},
			timer: 2000,
			timerProgressBar: true 
		});
	}

	window.activeCompanyTab = "overview";

	window.companyDrawerElement = document.querySelector("#kt_drawer_view_company");
	window.companyDrawer = KTDrawer.getInstance(window.companyDrawerElement);

	window.companyDrawer.on("kt.drawer.shown", function() {
		document.body.classList.add('drawer-open');
	});

	window.companyDrawer.on("kt.drawer.hide", function() {
		document.body.classList.remove('drawer-open');
	});

	window.companyDrawer.on("kt.drawer.shown", function() {
		// Wait 1 second then run the line below
		setTimeout(function() {
			window.phoneFormatter("#company_phone");

			$("#last_contact").flatpickr({
				enableTime: false,
				dateFormat: "m/d/Y",
			});

			$("#follow_up_date").flatpickr({
				enableTime: false,
				dateFormat: "m/d/Y",
			});

		}, 750);
	});

	window.currentCompanyID = 0;

	window.viewCompany = function(event, id) {                                     
		event.preventDefault();

		if(window.dealCompaniesDataTable) {
			window.dealCompaniesDataTable.draw();
		}

		if(window.contactDrawer) {
			window.contactDrawer.hide();
		}


		KTDrawer.getInstance(document.querySelector("#kt_activities")).hide();

		window.companyDrawer.hide();
		window.currentCompanyID = id;
		$.ajax({
			type: "GET",
			url: "/companies/getview/id/" + id,
			success: function (data) {
				$("#company_profile_contents").html(data);
			}
		});

		window.companyDrawer.show();
		
	}

	window.addCompanyNote = function() {
		
		var csrf_token = $('meta[name="csrf-token"]').attr('content');

		$.ajax({
			type: "POST",
			url: "/companies/notes/add",
			data: { 
				_token: csrf_token,
				company_id: window.currentCompanyID,
				note: $("#company_new_note").val(),
			},
			success: function (data) {
				window.toastSuccess("You have successfully added a note!");
				window.companyNotesDataTable.draw();
			},
			error: function (data, textStatus, errorThrown) {
				Swal.fire({
					text: "An error occurred. please try again.",
					icon: "error",
					buttonsStyling: false,
					confirmButtonText: "Ok",
					customClass: {
						confirmButton: "btn fw-bold btn-darkblue",
					}
				});
			},
		});
	}


	$("#company_profile_save").on("click", function() {
		jQuery("#form_"+window.activeCompanyTab).submit();
		$.each($.fn.dataTable.tables(), function() {
			$(this).DataTable().draw();
		});
	});

	window.editCompanySummary = function() {
		$("#company_summary").addClass("hidden");
		$("#company_summary_edit").removeClass("hidden");
	}

	window.editCompanyDetails = function() {
		$("#company_details").addClass("hidden");
		$("#company_details_edit").removeClass("hidden");
	}

	window.unserializeFormData = function(formData) {
		var params = {};
		formData.split('&').forEach(function(pair) {
			var [key, value] = pair.split('=');
			key = decodeURIComponent(key);
			value = decodeURIComponent(value);
			if (params[key]) {
				if (Array.isArray(params[key])) {
					params[key].push(value);
				} else {
					params[key] = [params[key], value];
				}
			} else {
				params[key] = value;
			}
		});
		return params;
	}

	window.showCompanyTab = function(tab) {
		$(".contactviewnav").removeClass("active");
		$("#tab_company_"+tab).addClass("active");
		window.activeCompanyTab = tab;
		$(".companytab").addClass("hidden");
		$("#tab_"+tab).removeClass("hidden");
	}

	$(".company_profile_close_button").on("click", function() {
		window.companyDrawer.hide();
	});

    function onPageChange() {
		$('a').each(function() {

			if (!$(this).attr('on-click-set')) {
				$(this).attr('on-click-set', 'true');

				var href = $(this).attr('href');

				if(!href) {
					return;
				}

				var pattern = /\/deals\/([^/]+)\/id\/(\d+)/;
				var match = href.match(pattern);
				if (match) {

					$(this).on('click', function(event) {

						event.preventDefault();

						var dealID = match[2];
						var csrf_token = $('meta[name="csrf-token"]').attr('content');
						$.ajax({
							type: "POST",
							url: "/deals/checkaccess/id/" + dealID,
							data: { 
								_token: csrf_token,
							},
							success: function (data) {
								if(data != "yes") {
									$("#request_access_deal_users").html(data);
									KTApp.initBootstrapTooltips();
									$("#kt_modal_request_access").modal('show');
								} else {
									window.location.href = href;
								}
							}
						});
					});
				}
			}
		});
    }

    var observer = new MutationObserver(function(mutationsList, observer) {
        mutationsList.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                onPageChange();
            }
        });
    });

    var targetNode = document.body;

    var config = {
        childList: true,
        subtree: true
    };

    observer.observe(targetNode, config);

    $(window).on('unload', function() {
        observer.disconnect();
    });

	$("#kt_modal_request_access_cancel").on("click", function() {
		$("#kt_modal_request_access").modal('hide');
	});

	$("#kt_modal_request_access_submit").on("click", function() {
		var csrf_token = $('meta[name="csrf-token"]').attr('content');
	});


	window.toggleMap = function() {	
		if ($("#show_map_toggle").is(":checked")) {
			window.location.href = "/propertymap/map";
		} else {
			window.location.href = "/propertymap/list";
		}
	}
  
	$('#referral_contact_id').select2({
		minimumInputLength: 2,
		delay: 250,
		cache: true,
		dataType: 'json',
		ajax: {
			url: "/customer/search",
			dataType: 'json'
		}
	});

	$('#referral_contact_id').on('select2:select', function (e) {
		$('#add_referral_contact_id').val(e.params.data.id);
		$('#add_referral_contact_form').submit();
	});

	if (getCookie('asideState') === 'minimized') {
		$('#kt_aside_toggle').click();
	}
	
	$('#kt_aside_toggle').on('click', function () {
		if (getCookie('asideState') === 'minimized') {
			jQuery("#kt_aside_menu_wrapper").removeClass("force75wide");
			document.cookie = 'asideState=maximized; expires=Thu, 01 Jan 2030 00:00:00 UTC; path=/;';
		} else {
			jQuery("#kt_aside_menu_wrapper").addClass("force75wide");

			document.cookie = 'asideState=minimized; expires=Thu, 01 Jan 2030 00:00:00 UTC; path=/;';
		}
	});
	
	function getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) {
			return parts.pop().split(';').shift();
		}
	}

    const deleteTaskButtons = document.querySelectorAll('#delete_task');

    deleteTaskButtons.forEach(d => {

        d.addEventListener('click', function (e) {
            e.preventDefault();

            const parent = e.target.closest('.menu-sub-dropdown');

            const rowID = parent.querySelectorAll("input[type='hidden']")[0].value;

            Swal.fire({
                text: "Are you sure you want to delete this task?",
                icon: "warning",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
				showCancelButton: true,
                buttonsStyling: false,
                customClass: {
                    confirmButton: "btn fw-bold btn-danger",
                    cancelButton: "btn fw-bold btn-active-light-primary"
                }
            }).then(function (result) {
                if (result.value) {
                    
                    var csrf_token = $('meta[name="csrf-token"]').attr('content');

                    $.ajax({
                        type: "POST",
                        url: "/deals/deletetask/id/" + rowID,
                        data: { _token: csrf_token },
                        success: function (data) {
							window.toastSuccess("You have successfully deleted this task!");
							$("#task_row_"+rowID).hide('slow');
                        },
                        error: function (data, textStatus, errorThrown) {
                            Swal.fire({
                                text: "An error occurred. please try again.",
                                icon: "error",
                                buttonsStyling: false,
                                confirmButtonText: "Ok, got it!",
                                customClass: {
                                    confirmButton: "btn fw-bold btn-primary",
                                }
                            });
                        },
                    });

                } else if (result.dismiss === 'cancel') {

                    Swal.fire({
                        text: "The task was not deleted.",
                        icon: "error",
                        buttonsStyling: false,
                        confirmButtonText: "Ok, got it!",
                        customClass: {
                            confirmButton: "btn fw-bold btn-primary",
                        }
                    });
                
                }
            });
        })
    });


    const editTaskButtons = document.querySelectorAll('#edit_task');

    editTaskButtons.forEach(d => {
        // Delete button on click
        d.addEventListener('click', function (e) {

            e.preventDefault();

            // Select parent row
            const parent = e.target.closest('.menu-sub-dropdown');

            const taskID = parent.querySelectorAll("input[type='hidden']")[0].value;

            var csrf_token = $('meta[name="csrf-token"]').attr('content');

            $.ajax({
                type: "POST",
                url: "/deals/gettaskinfo/id/" + taskID,
                data: { _token: csrf_token },
                success: function (data) {

                    const theInfo = jQuery.parseJSON(data);

                    var assignedToData = [];

                    Object.entries(theInfo.deal_users).forEach(([key, value]) => {
                        var item = {};
                        item.id = key;
                        item.text = value.name;
                        assignedToData.push(item);
                    });

                    $("#kt_modal_edit_task").find("#assigned_to").select2({
                        dropdownParent: $("#kt_modal_edit_task"),
                        data: assignedToData,
                    });

                    $("#kt_modal_edit_task").find("#title").val(theInfo.title);
                    $("#kt_modal_edit_task").find("#task_id").val(taskID);                        
                    
                    $("#kt_modal_edit_task").find("#assigned_to").val(theInfo.assigned_to_id).change();
                    
                    $("#kt_modal_edit_task").find("#details").val(theInfo.details);
                    $("#kt_modal_edit_task").find("#due_date").val(theInfo.due_date);
                    $("#kt_modal_edit_task").modal('show');
                }
            });
        });
    });

    // Create Deal Modal
    $('#kt_modal_create_deal').on('show.bs.modal', function (event) {
        const flatpickr = require('flatpickr');
        $(".flatpickr-input").flatpickr({
            enableTime: false,
            dateFormat: "m/d/Y",
        });     	

		setTimeout(function() {
			$('#deal_owner').select2();

			$('#deal_owner').on('change', function () {
				let selectedValue = $(this).val();
				Livewire.dispatch('setCreateModalDealOwner', { userId: selectedValue });
			});
	
		}, 1000);

	});

	window.defaultNewModal = 'deal_details';

	$("#new_deal_link").on("click", function() {
		window.defaultNewModal = 'deal_details';
		$("#kt_modal_create_deal").modal('show');
	});


	$("#new_portfolio_link").on("click", function() {
		window.defaultNewModal = 'deal_portfolio_details';
		$("#kt_modal_create_deal").modal('show');
	});

	$('#kt_modal_create_deal').on('show.bs.modal', function (event) {
		Livewire.dispatch('setStepOneValue', { data: window.defaultNewModal});
		window.defaultNewModal = 'deal_details';
	});

	$(".theTaskNameDiv").click(function(e) {
		e.preventDefault();
		const taskID = $(this).parent().parent().find(".btnCompleteTask").prop("value");
		// Ensure Livewire is available
		if (typeof Livewire !== 'undefined') {
			Livewire.dispatch('loadTaskInfo', { taskId: taskID });
		} else {
			console.error('Livewire is not defined');
		}
	});

    // Click Complete Task Modal
    $(".btnCompleteTask").click(function() {
        const theCheckbox = $(this);
        const taskID = theCheckbox.val();
        const completingTask = theCheckbox.prop("checked");
        if(completingTask) {
            Swal.fire({
                text: "Are you sure you want to mark this task complete?",
                icon: "warning",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
				showCancelButton: true,
                buttonsStyling: false,
                customClass: {
                    confirmButton: "btn fw-bold btn-darkblue",
                    cancelButton: "btn fw-bold btn-active-light-primary"
                }
            }).then(function (result) {
                if (result.value) {
                    var csrf_token = $('meta[name="csrf-token"]').attr('content');
                    $.ajax({
                        type: "POST",
                        url: "/deals/completetask/id/" + taskID,
                        data: { _token: csrf_token },
                        success: function (data) {
							window.toastSuccess("Task marked as complete!");
                            $("#task_row_"+taskID).hide('slow');
							Livewire.dispatch('refreshDashboardStats');
                        },
                        error: function (data, textStatus, errorThrown) {
                            Swal.fire({
                                text: "An error occurred. please try again.",
                                icon: "error",
                                buttonsStyling: false,
                                confirmButtonText: "Ok, got it!",
                                customClass: {
                                    confirmButton: "btn fw-bold btn-primary",
                                }
                            });
                             theCheckbox.prop("checked", false);
                        },
                    });
                } else if (result.dismiss === 'cancel') {
                    theCheckbox.prop("checked", false);
                }
            });
        }
    });
});

// Class definition
var KTModalEditTask = function () {
    var submitButton;
    var cancelButton;
    var validator;
    var form;
    var modal;
    var modalEl;

    // Init form inputs
    var initForm = function() {
        const flatpickr = require('flatpickr');
        var dueDate = $("#kt_modal_edit_task").find("#due_date");
        dueDate.flatpickr({
            enableTime: false,
            dateFormat: "m/d/Y",
        });
    }

    var handleForm = function() {
        submitButton.addEventListener('click', function (e) {
            e.preventDefault();

            var isValid = true;

            if($("#task_title").val() == "") {
                $("#kt_modal_edit_task").find("#task_title_feedback").html("Title is a required value.");
                isValid = false;
            } else {
                $("#kt_modal_edit_task").find("#task_title_feedback").html();
            }

            if(isValid) {
                submitButton.setAttribute('data-kt-indicator', 'on');

                // Disable button to avoid multiple click  
                submitButton.disabled = true;

                const theDueDate = $("#kt_modal_edit_task").find("#due_date").val();

                $.ajax({
                    type: "POST",
                    url: "/deals/edittask/id/" + $("#task_id").val(),
                    data: { 
                        details: $("#kt_modal_edit_task").find("#details").val(),
                        notify_email: $("#kt_modal_edit_task").find("#notify_email:checked").val(),
                        notify_text: $("#kt_modal_edit_task").find("#notify_text:checked").val(),
                        _token: $('meta[name="csrf-token"]').attr('content'), 
                        title: $("#kt_modal_edit_task").find("#title").val(),
                        assigned_to: $("#kt_modal_edit_task").find("#assigned_to").val(),
                        due_date: theDueDate,
                    },
                    success: function (data) {
                        location.reload();
                    },
                    error: function (data, textStatus, errorThrown) {
                        Swal.fire({
                            text: "An error occurred. please try again.",
                            icon: "error",
                            buttonsStyling: false,
                            confirmButtonText: "Ok, got it!",
                            customClass: {
                                confirmButton: "btn fw-bold btn-primary",
                            }
                        });
                        submitButton.removeAttribute('data-kt-indicator');
                        submitButton.disabled = false;
                    },
                });
            }
        });

        cancelButton.addEventListener('click', function (e) {
            modal.hide(); // Hide modal             
        });
    }

    return {
        // Public functions
        init: function () {
            // Elements
            modalEl = document.querySelector('#kt_modal_edit_task');

            if (!modalEl) {
                return;
            }

            modal = new bootstrap.Modal(modalEl);

            submitButton = document.getElementById('kt_modal_edit_task_submit');
            cancelButton = document.getElementById('kt_modal_edit_task_cancel');

            initForm();
            handleForm();

        }
    };
}();

// On document ready
KTUtil.onDOMContentLoaded(function () {
    KTModalEditTask.init();

    if(jQuery("#2fainputdiv").length) {
        jQuery("#code_1").on('input',function(e){
            jQuery("#code_2").focus();
        });
        jQuery("#code_2").on('input',function(e){
            jQuery("#code_3").focus();
        });
        jQuery("#code_3").on('input',function(e){
            jQuery("#code_4").focus();
        });
        jQuery("#code_4").on('input',function(e){
            jQuery("#code_5").focus();
        });
        jQuery("#code_5").on('input',function(e){
            jQuery("#code_6").focus();
        });
        jQuery("#code_6").on('input',function(e){
            
        });
    }

	if(("#to_call_contact_id").length) {
		$('#to_call_contact_id').select2({
			dropdownParent: $("#kt_modal_add_event"),
			minimumInputLength: 2,
			delay: 250,
			cache: true,
			dataType: 'json',
			ajax: {
				url: "/callfollowup/search",
				dataType: 'json'
			}
		});
	}

	jQuery("#markAllNotificationsAsRead").on('click', function(e) {
		jQuery.ajax({
            url: '/notifications/markallasread',
            method: 'GET',
            dataType: 'html',
            success: function (data) {
                $('#notification_tabs').html(data);
            }
        });
	});


	jQuery("#tab_link_all").on("click", function(e) {
		jQuery("#kt_notifications_footer").hide();
	});

	jQuery("#tab_link_unread").on("click", function(e) {
		jQuery("#kt_notifications_footer").show();
	});

	jQuery(".notificationNav").click(function() {
		jQuery(".notificationNav").addClass("inactive");
		jQuery(this).removeClass("inactive");
	});

	window.showAllNotifications = function() {
		$('#kt_notifications_footer').hide();
	}

	window.showUnreadNotifications = function() {
		$('#kt_notifications_footer').show();
	}

	window.markAsUnread = function(theID) {
		jQuery.ajax({
			url: '/notifications/markasunread/id/' + theID,
			method: 'GET',
			dataType: 'html',
			success: function (data) {
				$('#tab_link_all').addClass("inactive");
				$('#tab_link_unread').removeClass("inactive");
				$('#notification_tabs').html(data);
			}
		});	
	}

	window.markAsRead = function(theID) {
		jQuery.ajax({
			url: '/notifications/markasread/id/' + theID,
			method: 'GET',
			dataType: 'html',
			success: function (data) {
				$('#notification_tabs').html(data);
			}
		});	
	}

	jQuery("#followup_add_new").on("click", function() {

		$("#kt_modal_add_event").modal('show');
	
		var initialMessage = "Select A Contact";
	
		var contactInfoBlock = new KTBlockUI(document.querySelector("#contact_info"), {
			message: '<div class="blockui-message">' + initialMessage + '</div>',
		});
	
		var contactNotesBlock = new KTBlockUI(document.querySelector("#contact_notes"), {
			message: '<div class="blockui-message">' + initialMessage + '</div>',
		});
	
		var contactSendEmailBlock = new KTBlockUI(document.querySelector("#contact_send_email"), {
			message: '<div class="blockui-message">' + initialMessage + '</div>',
		});
	
		var contactAssignDateBlock = new KTBlockUI(document.querySelector("#contact_assign_date"), {
			message: '<div class="blockui-message">' + initialMessage + '</div>',
		});
	
		if(contactInfoBlock) {
			contactInfoBlock.block();
		}
		contactNotesBlock.block();  
		contactSendEmailBlock.block();  
		contactAssignDateBlock.block();  
	
		jQuery("#select_contact_container").show();
	
	
		$('#to_call_contact_id').on("change", function(e) {
			var contactId = $('#to_call_contact_id').val(); 
			var csrf_token = $('meta[name="csrf-token"]').attr('content');
		
			var tmp = contactId.split("|");
			var type = tmp[0];
			var id = tmp[1];
	
			jQuery("#follow_up_type").val(type);
			jQuery("#follow_up_contact_id").val(id);
	
			$.ajax({
				type: "POST",
				url: "/callfollowup/details",
				data : { 
					_token: csrf_token, 
					contact_id: contactId
				},
				success: function (data) {
	
					jQuery("#contact_name").html("<a href='#' onClick='window.viewContact(event, " + data.id + ")'>" + data.first_name + ' ' + data.last_name + "</a>");
					jQuery("#contact_address").html(data.street + ' ' + data.city + ', ' + data.state + ' ' + data.zip);
					jQuery("#contact_type").html(data.type);
	
					if(data.phone) {
						jQuery("#contact_phone").html("<a href='tel:" + data.phone + "'>" + data.phone + "</a>");
					} else {
						jQuery("#contact_phone").hide();
					}
					if(data.email) {
						jQuery("#contact_email").html("<a href='mailto:" + data.email + "'>" + data.email + "</a>");
						jQuery("#compose_to").val(data.email);
					} else {
						jQuery("#contact_email").hide();
					}
	
					jQuery("#contact_note").html(data.note);
					jQuery("#contact_note_date").html(data.note_date);
					jQuery("#follow_up_date").val();
				},
			});
	
			if(contactInfoBlock) {
				contactInfoBlock.release();  
			}
			contactNotesBlock.release();
			contactSendEmailBlock.release();
			contactAssignDateBlock.release();
		});
	});

	jQuery("#followup_add_new_from_contact").on("click", function() {

		$("#kt_modal_add_event").modal('show');
		jQuery("#select_contact_container").show();
		var csrf_token = $('meta[name="csrf-token"]').attr('content');
		var contactId = $('#init_followup_contact_id').val();

		var tmp = contactId.split("|");
		var type = tmp[0];
		var id = tmp[1];

		jQuery("#follow_up_type").val(type);
		jQuery("#follow_up_contact_id").val(id);

		$.ajax({
			type: "POST",
			url: "/callfollowup/details",
			data : { 
				_token: csrf_token, 
				contact_id: contactId
			},
			success: function (data) {

				jQuery("#contact_name").html("<a href='#' onClick='window.viewContact(" + data.id + ")'>" + data.first_name + ' ' + data.last_name + "</a>");
				jQuery("#contact_address").html(data.street + ' ' + data.city + ', ' + data.state + ' ' + data.zip);
				jQuery("#contact_type").html(data.type);

				if(data.phone) {
					jQuery("#contact_phone").html("<a href='tel:" + data.phone + "'>" + data.phone + "</a>");
				} else {
					jQuery("#contact_phone").hide();
				}
				if(data.email) {
					jQuery("#contact_email").html("<a href='mailto:" + data.email + "'>" + data.email + "</a>");
					jQuery("#compose_to").val(data.email);
				} else {
					jQuery("#contact_email").hide();
				}

				jQuery("#contact_note").html(data.note);
				jQuery("#contact_note_date").html(data.note_date);
				jQuery("#follow_up_date").val();

				jQuery("#select_contact_container").hide();
			},
		});

	});
	
    jQuery("#followup_save").on("click", function(e) {

        var csrf_token = $('meta[name="csrf-token"]').attr('content');

        var theDate = jQuery("#follow_up_date").val();

        if(!theDate) {
            Swal.fire(
                'Follow Up Date Required',
                'Please select a follow up date to continue',
                'error'
            );
            return;
        }

        if(!jQuery("#follow_up_contact_id").val()) {

            var contactId = jQuery("#to_call_contact_id").val(); 

            if(!contactId) {
                Swal.fire(
                    'Contact Required',
                    'Please select a contact to continue',
                    'error'
                );
                return;
            }

            var tmp = contactId.split("|");
            var type = tmp[0];
            var id = tmp[1];

            jQuery("#follow_up_type").val(type);
            jQuery("#follow_up_contact_id").val(id);
        } else {
            var contactId = "contact|" + jQuery("#follow_up_contact_id").val();
        } 
        //======================================================
        // Check to see if we need to ADD or EDIT the follow up.
        //=======================================================
        if(jQuery("#follow_up_id").val() == "") {

            // Add the new follow up

            $.ajax({
                type: "POST",
                url: "/callfollowup/create",
                data : { 
                    _token: csrf_token, 
                    id: contactId,
                    follow_up_date: theDate,
                },
                success: function (data) {
					
					jQuery("#follow_up_id").val(data);
					location.reload();
                    
                },
            });

        } else {

            // Edit the follow up
            $.ajax({
                type: "POST",
                url: "/callfollowup/edit",
                data : { 
                    _token: csrf_token, 
                    id: contactId,
                    follow_up_date: theDate,
                    follow_up_id: jQuery("#follow_up_id").val(),
                },
                success: function (data) {
					
					jQuery("#follow_up_id").val(data);
					location.reload();
                    
                },
            });

        }
    });

    jQuery("#followup_send_email").on("click", function(e) {
        var csrf_token = $('meta[name="csrf-token"]').attr('content');

        $.ajax({
            type: "POST",
            url: "/callfollowup/send",
            data : { 
                _token: csrf_token, 
                to_email: jQuery("#compose_to").val(),
                contents: jQuery("#kt_inbox_form_editor > div").html(),
                subject: jQuery("#compose_subject").val(),
            },
            success: function (data) {
                window.toastSuccess("Your Email was sent!");
            },
        });
    });

    jQuery("#contact_add_note_btn").on("click", function(e) {

        var csrf_token = $('meta[name="csrf-token"]').attr('content');
    
        var id = jQuery("#follow_up_contact_id").val();

        $.ajax({
            type: "POST",
            url: "/callfollowup/contact/addnote",
            data : { 
                _token: csrf_token, 
                id: id,
                new_note: jQuery("#contact_new_note_field").val(),
            },
            success: function (data) {
                jQuery("#contact_note").html(data.note);
                jQuery("#contact_note_date").html(data.note_date);
                jQuery("#contact_new_note_field").val("");

				window.toastSuccess("Your note was successfully added!");
            },
        });
    });

	window.initQuillFollowup = false;

	window.doInitFollowUp = function() {
		if($("#kt_inbox_form_editor").length) {
			if(window.initQuillFollowup === false) {
				var quill = new Quill('#kt_inbox_form_editor', {
					modules: {
						toolbar: [
							[{
								header: [1, 2, false]
							}],
							['bold', 'italic', 'underline'],
							['image', 'code-block']
						]
					},
					placeholder: '',
					theme: 'snow' // or 'bubble'
				});

				window.initQuillFollowup = true;

			}
		}

		if($("#follow_up_date").length) {
			const flatpickr = require('flatpickr');
			var dueDate = $("#follow_up_date");
			dueDate.flatpickr({
				enableTime: false,
				dateFormat: "m/d/Y",
			});
		}
	}

	window.doInitFollowUp();


	$("#contact_create_email").on("change", function() {
		window.checkContactEmailAndPhone();
	});

	$("#contact_create_phone").on("change", function() {
		window.checkContactEmailAndPhone();
	});

	window.checkContactEmailAndPhone = function() {

		var theEmail = $("#contact_create_email").val();
		var thePhone = $("#contact_create_phone").val();

		if(theEmail == "") {
			theEmail = "null";
		}

		if(thePhone == "") {
			thePhone = "null";
		}
		
		$.ajax({
			type: "GET",
			url: "/contacts/check/email/" + theEmail + "/phone/" + thePhone,      
			success: function (data) {

				if(data.emailExists) {
					window.disableAddContactForm();
					jQuery(".contact_create_email_error").show();
					$("#existingContactOwner").html(data.assignedUserHtml);
				} else {
					jQuery(".contact_create_email_error").hide();
					$("#existingContactOwner").html(data.assignedUserHtml);
				}

				if(data.phoneExists) {
					window.disableAddContactForm();
					jQuery(".contact_create_phone_error").show();
					$("#existingContactOwner").html(data.assignedUserHtml);
				} else {
					jQuery(".contact_create_phone_error").hide();
					$("#existingContactOwner").html(data.assignedUserHtml);
				}

				if(!data.emailExists && !data.phoneExists) {
					window.enableAddContactForm();
				}
			}
		});

	}

	window.disableAddContactForm = function() {
		jQuery("#kt_modal_add_contact_submit").attr("disabled", "true");
	}

	window.enableAddContactForm = function() {
		jQuery("#kt_modal_add_contact_submit").removeAttr("disabled");
	}

	window.editContactGroup = function(groupName, groupID) {
		$("#kt_modal_edit_contact_group").modal("show");
		$("#kt_modal_edit_contact_group_id").val(groupID);
		$("#kt_modal_edit_contact_group_name").val(groupName);
	}

	window.resetAddContactModalValues = function() {
		$("#kt_modal_add_contact").modal("hide");
		$("#contact_create_first_name").val(""); 
		$("#contact_create_last_name").val(""); 
		$("#contact_create_type_id").val("");
		$("#contact_create_company_id").val("");
		$("#contact_create_title").val("");
		$("#contact_create_email").val("");
		$("#contact_create_phone").val("");
		$("#contact_create_street").val("");
		$("#contact_create_city").val("");
		$("#contact_create_state").val("");
		$("#contact_create_zip").val("");
		$("#contact_create_group_ids").val("");
		$("#contact_create_tags").val("");
		$("#contact_note").val("");
	}

	$("#kt_modal_add_contact_cancel").on("click", function() {
		$("#kt_modal_add_contact").modal("hide");
		window.resetAddContactModalValues();
	});

	$("#kt_modal_add_contact_submit").on("click", function() {

		var isValid = true;

		if($("#contact_create_first_name").val() == "") {
			isValid = false;
		}

		if($("#contact_create_last_name").val() == "") {
			isValid = false;
		}

		if($("#contact_create_type_id").val() == "") {
			isValid = false;
		}

		if($("#contact_create_email").val() == "") {
			isValid = false;
		}

		if($("#contact_create_phone").val() == "") {
			isValid = false;
		}

		if(isValid) {
			var csrf_token = $('meta[name="csrf-token"]').attr('content');

			$.ajax({
				type: "POST",
				url: "/contacts/add",
				data : { 
					_token: csrf_token, 
					first_name: $("#contact_create_first_name").val(), 
					last_name: $("#contact_create_last_name").val(), 
					type_id: $("#contact_create_type_id").val(),
					company_id: $("#contact_create_company_id").val(),
					company_name: $("#contact_create_company_id option:selected").text(),
					title: $("#contact_create_title").val(),
					email: $("#contact_create_email").val(),
					phone: $("#contact_create_phone").val(),
					street: $("#contact_create_street").val(),
					city: $("#contact_create_city").val(),
					state: $("#contact_create_state").val(),
					zip: $("#contact_create_zip").val(),
					group_ids: $("#contact_create_group_ids").val(),
					tags: $("#contact_create_tag_ids").val(),
					note: $("#contact_create_note").val(),
				},
	
				success: function (data) {
					window.toastSuccess("New Contact Created!");
					Livewire.dispatch('refreshDashboardStats');
					$("#kt_modal_add_contact").modal("hide");
					window.resetAddContactModalValues();
				},
				error: function (data, textStatus, errorThrown) {
					Swal.fire({
						text: "An error occurred. please try again.",
						icon: "error",
						buttonsStyling: false,
						confirmButtonText: "Ok",
						customClass: {
							confirmButton: "btn fw-bold btn-darkblue",
						}
					});
				},
			});
		} else {
			Swal.fire({
				text: "Please fill in all required fields.",
				icon: "error",
				buttonsStyling: false,
				confirmButtonText: "Ok",
				customClass: {
					confirmButton: "btn fw-bold btn-darkblue",
				}
			});
		}

		
	});

	window.addContactTags = new Tagify(document.querySelector("#contact_create_tag_ids"), {
		whitelist: window.allTags,
		maxTags: 30,
		dropdown: {
			position: "input",
			enabled: 0,
			maxItems: 99999999,
			closeOnSelect: false
		}
	});

	window.addContactGroups = new Tagify(document.querySelector("#contact_create_group_ids"), {
		whitelist: window.allGroups,
		maxTags: 1,
		dropdown: {
			position: "input",
			enabled: 0,
			maxItems: 99999999,
			closeOnSelect: false
		}
	});

	$("#kt_modal_add_company_cancel").on("click", function() {
		jQuery("#kt_modal_new_company").modal('hide');
	});

	$("#kt_modal_add_company_submit").on("click", function() {
		var csrf_token = $('meta[name="csrf-token"]').attr('content');

		$.ajax({
			type: "POST",
			url: "/companies/add",
			data : { 
				_token: csrf_token, 
				name: $("#create_company_name").val(),
				phone: $("#create_company_phone").val(),
				email: $("#create_company_email").val(),
				address: $("#create_company_address").val(),
				city: $("#create_company_city").val(),
				state: $("#create_company_state").val(),
				zip: $("#create_company_zip").val(),
				type_id: $("#create_company_type_id").val(),
			},

			success: function (data) {
				window.toastSuccess("New Company Created!");
				jQuery("#kt_modal_new_company").modal('hide');
				const thePage = window.companiesDataTable.page();
				window.companiesDataTable.draw();
				window.companiesDataTable.page(thePage);
			},
			error: function (data, textStatus, errorThrown) {
				Swal.fire({
					text: "An error occurred. please try again.",
					icon: "error",
					buttonsStyling: false,
					confirmButtonText: "Ok",
					customClass: {
						confirmButton: "btn fw-bold btn-darkblue",
					}
				});
			},
		});
	});

	window.reloadCreateContact = false;

	$("#kt_modal_new_company").on("hidden.bs.modal", function() {
		if(window.reloadCreateContact) {
			jQuery("#kt_modal_add_contact").modal('show');
			window.reloadCreateContact = false;
		}
	});

    $('#kt_modal_add_contact').on('shown.bs.modal', function () {
		window.initCreateContactAutocomplete();

		$("#contact_create_type_id").select2({
			dropdownParent: $("#kt_modal_add_contact"),
			minimumInputLength: 0,
		});

        $('#contact_create_company_id').select2({
            minimumInputLength: 2,
            delay: 250,
            cache: true,
            ajax: {
                url: "/company/search",
                dataType: 'json',
            },
            tags: true,
            createTag: function (params) {

                var term = $.trim(params.term);
                if (term === '') {
                    return null;
                }
                return {
                    id: 'NEW',
                    text: term,
                    newTag: true // add additional parameters
                };
            },
			
            templateResult: function (data) {
                if (data.newTag) {
                    return $('<span>Create new company: <strong>' + data.text + '</strong></span>');
                }
                return data.text;
            }
				
        });

		window.phoneFormatter("#contact_create_phone");

        $('#contact_create_company_id').on('select2:select', function(e) {
            if(e.params.data.id == "NEW") {
                $("#kt_modal_add_contact").modal('hide');
                $("#kt_modal_new_company").modal('show');
				$("#company_name").val(e.params.data.text);			
				window.reloadCreateContact = true;
            }
        });
    });

	window.initCreateNewPortfolioAutocomplete = function(id) {
		var element = document.getElementById('portfolio_street_line_one');
		if (element) {
			var autocomplete = new google.maps.places.Autocomplete(element, { types: ['geocode'] });
			google.maps.event.addListener(autocomplete, 'place_changed', window.setCreateNewPortfolioAddress);
		}
	}

	window.setCreateNewPortfolioAddress = function() {
		var place = this.getPlace();

		var city = '';
		var state = '';
		var zipcode = '';
		var street_number = '';
		var route = '';

		for (var i in place.address_components) {
			var component = place.address_components[i];
			for (var j in component.types) {  // Some types are ["country", "political"]
				switch(component.types[j]) {
					case 'street_number':
						street_number = component.long_name;
						break;
					case 'route':
						route = component.long_name;
						break;
					case 'locality':
						city = component.long_name;
						break;
					case 'administrative_area_level_1':
						state = component.short_name;
						break;
					case 'postal_code':
						zipcode = component.long_name;
						break;
				}
			}
		}


		var addressData = {
			'street_line_one': street_number + ' ' + route,
			'city': city,
			'state': state,
			'zip_code': zipcode
		};

		Livewire.dispatch('setPortfolioAddress', { data: addressData });

	}

	window.initCreateNewDealAutocomplete = function(id) {
		var element = document.getElementById('property_street_line_one');
		if (element) {
			var autocomplete = new google.maps.places.Autocomplete(element, { types: ['geocode'] });
			google.maps.event.addListener(autocomplete, 'place_changed', window.setCreateNewDealAddress);
		}
	}

	window.setCreateNewDealAddress = function() {
		var place = this.getPlace();

		var city = '';
		var state = '';
		var zipcode = '';
		var street_number = '';
		var route = '';

		for (var i in place.address_components) {
			var component = place.address_components[i];

			for (var j in component.types) {  // Some types are ["country", "political"]

				switch(component.types[j]) {
					case 'street_number':
						street_number = component.long_name;
						break;
					case 'route':
						route = component.long_name;
						break;
					case 'locality':
						city = component.long_name;
						break;
					case 'administrative_area_level_1':
						state = component.short_name;
						break;
					case 'postal_code':
						zipcode = component.long_name;
						break;
				}
			}
		}

		var addressData = {
			'street_line_one': street_number + ' ' + route,
			'city': city,
			'state': state,
			'zip_code': zipcode
		};

		Livewire.dispatch('setDealAddress', { data: addressData });
	}


	window.initDealAutocomplete = function(id) {
		var element = document.getElementById('street_line_one');
		if (element) {
			var autocomplete = new google.maps.places.Autocomplete(element, { types: ['geocode'] });
			google.maps.event.addListener(autocomplete, 'place_changed', window.setCreateDealAddress);
		}
	}

	window.setCreateDealAddress = function() {
		var place = this.getPlace();

		var city = '';
		var state = '';
		var zipcode = '';
		var street_number = '';
		var route = '';

		for (var i in place.address_components) {
			var component = place.address_components[i];
			for (var j in component.types) {  // Some types are ["country", "political"]
				switch(component.types[j]) {
					case 'street_number':
						street_number = component.long_name;
						break;
					case 'route':
						route = component.long_name;
						break;
					case 'locality':
						city = component.long_name;
						break;
					case 'administrative_area_level_1':
						state = component.short_name;
						break;
					case 'postal_code':
						zipcode = component.long_name;
						break;
				}
			}
		}

		$("#street_line_one").val(street_number + ' ' + route);
		$("#city").val(city);
		$("#state").val(state).change();
		$("#zip_code").val(zipcode);

	}


	
	window.initCreateContactAutocomplete = function(id) {
		var element = document.getElementById('contact_create_street');
		if (element) {
			var autocomplete = new google.maps.places.Autocomplete(element, { types: ['geocode'] });
			google.maps.event.addListener(autocomplete, 'place_changed', window.setCreateContactAddress);
		}
	}

	window.setCreateContactAddress = function() {
		var place = this.getPlace();

		var city = '';
		var state = '';
		var zipcode = '';
		var street_number = '';
		var route = '';

		for (var i in place.address_components) {
			var component = place.address_components[i];
			for (var j in component.types) {  // Some types are ["country", "political"]
				switch(component.types[j]) {
					case 'street_number':
						street_number = component.long_name;
						break;
					case 'route':
						route = component.long_name;
						break;
					case 'locality':
						city = component.long_name;
						break;
					case 'administrative_area_level_1':
						state = component.short_name;
						break;
					case 'postal_code':
						zipcode = component.long_name;
						break;
				}
			}
		}

		$("#contact_create_street").val(street_number + ' ' + route);
		$("#contact_create_city").val(city);
		$("#contact_create_state").val(state).change();
		$("#contact_create_zip").val(zipcode);

	}

	$('#kt_modal_new_company').on('show.bs.modal', function (e) {
		$("#create_company_name").val("");
		$("#create_company_phone").val("");
		$("#create_company_email").val("");
		$("#create_company_address").val("");
		$("#create_company_city").val("");
		$("#create_company_state").val("");
		$("#create_company_zip").val("");
		$("#create_company_type_id").val("");
	});

	$('#kt_modal_new_company').on('shown.bs.modal', function (e) {
		window.initCreateCompanyAutocomplete();
		window.phoneFormatter("#create_company_phone");

		jQuery("#create_company_type_id").select2({
			dropdownParent: jQuery("#kt_modal_new_company")
		});

	});
	
	window.initCreateCompanyAutocomplete = function(id) {
		var element = document.getElementById('create_company_address');
		if (element) {
			var autocomplete = new google.maps.places.Autocomplete(element, { types: ['geocode'] });
			google.maps.event.addListener(autocomplete, 'place_changed', window.setCreateCompanyAddress);
		}
	}

	window.setCreateCompanyAddress = function() {
		var place = this.getPlace();

		var city = '';
		var state = '';
		var zipcode = '';
		var street_number = '';
		var route = '';

		for (var i in place.address_components) {
			var component = place.address_components[i];
			for (var j in component.types) {  // Some types are ["country", "political"]
				switch(component.types[j]) {
					case 'street_number':
						street_number = component.long_name;
						break;
					case 'route':
						route = component.long_name;
						break;
					case 'locality':
						city = component.long_name;
						break;
					case 'administrative_area_level_1':
						state = component.short_name;
						break;
					case 'postal_code':
						zipcode = component.long_name;
						break;
				}
			}
		}

		$("#create_company_address").val(street_number + ' ' + route);
		$("#create_company_city").val(city);
		$("#create_company_state").val(state).change();
		$("#create_company_zip").val(zipcode);

	}

	window.initViewCompanyAutocomplete = function(id) {
		var element = document.getElementById('company_street_address');
		if (element) {
			var autocomplete = new google.maps.places.Autocomplete(element, { types: ['geocode'] });
			google.maps.event.addListener(autocomplete, 'place_changed', window.setViewCompanyAddress);
		}
	}

	window.setViewCompanyAddress = function() {
		var place = this.getPlace();

		var city = '';
		var state = '';
		var zipcode = '';
		var street_number = '';
		var route = '';

		for (var i in place.address_components) {
			var component = place.address_components[i];
			for (var j in component.types) {  // Some types are ["country", "political"]
				switch(component.types[j]) {
					case 'street_number':
						street_number = component.long_name;
						break;
					case 'route':
						route = component.long_name;
						break;
					case 'locality':
						city = component.long_name;
						break;
					case 'administrative_area_level_1':
						state = component.short_name;
						break;
					case 'postal_code':
						zipcode = component.long_name;
						break;
				}
			}
		}
		$("#company_street_address").val(street_number + ' ' + route);
		$("#company_city").val(city);
		$("#company_state").val(state).change();
		$("#company_zip").val(zipcode);
	}

	window.initAllMenus = function() {
		KTMenu.createInstances();
	}

	window.phoneFormatter = function(selector) {
		$(selector).on('input', function() {
			var input = $(this).val().replace(/\D/g, '');
			if (input.length > 10) {
				input = input.substring(0, 10);
			}
			if (input.length > 6) {
				input = input.replace(/(\d{3})(\d{3})(\d{1,4})/, '$1-$2-$3');
			} else if (input.length > 3) {
				input = input.replace(/(\d{3})(\d{1,3})/, '$1-$2');
			}
			$(this).val(input);
		});
	};

	window.showAdvancedSerach = function() {
        const dropdown = document.getElementById('advancedSearchMenu');
        dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
    }

    // Close the dropdown if the user clicks outside of it
    window.onclick = function(event) {
        if (!event.target.matches('.gear-icon')) {
            const dropdowns = document.getElementsByClassName("dropdown-menu");
            for (let i = 0; i < dropdowns.length; i++) {
                let openDropdown = dropdowns[i];
                if (openDropdown.style.display === 'block') {
                    openDropdown.style.display = 'none';
                }
            }
        }

		var searchResultsList = document.getElementById('headerSearchResultsList');
		if(searchResultsList) {
			var isClickInside = searchResultsList.contains(event.target);

			if (!isClickInside) {
				Livewire.dispatch('hideSearchResults');
			}
		}
	}

	window.toastUpdateContactSuccess = function(message) {
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-right",
			"preventDuplicates": true,
			"onclick": null,
			"showDuration": "1500",
			"hideDuration": "1500",
			"timeOut": "1500",
			"extendedTimeOut": "10000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut",
			"toastClass": "toastUpdateContactSuccess",
		}

		var msg = `<table>
			<tbody>
				<tr>
					<td>
						<div class="symbol symbol-50px symbol-circle" data-bs-toggle="tooltip" title="" data-bs-original-title="test test">
							<span class="symbol-label bg-lightpurple text-inverse-warning fw-bolder">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-vcard" viewBox="0 0 16 16">
									<path d="M5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8m1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5"/>
									<path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.96q.04-.245.04-.5C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1 1 0 0 1 1 12z"/>
								</svg>
							</span>
						</div>					
					</td>
					<td>
						` + message + `		  				
					</td>
				</tr>
			</tbody>
		</table>`;

		toastr.success(msg);
	}

	window.toastSuccess = function(message) {
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-right",
			"preventDuplicates": true,
			"onclick": null,
			"showDuration": "1500",
			"hideDuration": "1500",
			"timeOut": "1500",
			"extendedTimeOut": "10000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut",
			"toastClass": "doSuccess",
		}
		  
		var msg = `<table>
			<tr>
				<td>
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
						<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
						<path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
					</svg>
				</td>
				<td>
					` + message + `		  				
				</td>
			</tr>
		</table>`;

		toastr.success(msg);
	}

	if(window.theMessage != "") {
		if(window.theMessage !== undefined) {
			window.toastSuccess(window.theMessage);
		}
	}

	window.toastAlert = function(message) {
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-right",
			"preventDuplicates": false,
			"onclick": null,
			"showDuration": "1500",
			"hideDuration": "1500",
			"timeOut": "1500",
			"extendedTimeOut": "10000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut",
			"toastClass": "doAlert",
		}
		  
		var msg = `<table>
			<tr>
				<td>
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bell-fill" viewBox="0 0 16 16">
						<path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2m.995-14.901a1 1 0 1 0-1.99 0A5 5 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901"/>
					</svg>
				</td>
				<td>
					` + message + `		  				
				</td>
			</tr>
		</table>`;

		toastr.success(msg);
	}


	jQuery(".dataTables_filter label").each(function() {
		jQuery(this).contents().filter(function() { return this.nodeType === 3; }).remove();
	});


	jQuery(".dataTables_filter input").each(function() {
		jQuery(this).removeClass('form-control-sm')
			.addClass('form-control form-control-solid form-control-lg w-250px ps-15') // Add the custom class
			.wrap('<div class="d-flex align-items-center position-relative my-1"></div>') // Wrap input with a div for styling
			.attr("placeholder", "Search...") // Add placeholder
			.before(`<span class="svg-icon svg-icon-1 position-absolute ms-6">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
							<rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor"></rect>
							<path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor"></path>
						</svg>
					</span>`); // Add icon

	});

	jQuery(".dataTables_filter").each(function(index) {
		const incrementClass = `dataTables_filter_${index + 1}`;
		jQuery(this).addClass(incrementClass);

		const targetWrapper = `.setting-top-wrapper-${index + 1}`;
		jQuery(targetWrapper).append(jQuery(this));
	});

	window.activeContactTab = "overview";

	window.contactDrawerElement = document.querySelector("#kt_drawer_view_contact");
	window.contactDrawer = KTDrawer.getInstance(window.contactDrawerElement);

	window.contactDrawer.on("kt.drawer.shown", function() {
		document.body.classList.add('drawer-open');
	});

	window.contactDrawer.on("kt.drawer.hide", function() {
		document.body.classList.remove('drawer-open');
	});

	window.currentContactID = 0;

	window.scrollToTop = true;



	window.viewContact = function(event, id) {        
		event.preventDefault();

		if(window.dealContactsDataTable) {
			window.dealContactsDataTable.draw();
		}

		KTDrawer.getInstance(document.querySelector("#kt_activities")).hide();

		if(window.companyDrawer) {
			window.companyDrawer.hide();
		}
		
		if(jQuery("#kt_modal_add_event").length) {
			jQuery("#kt_modal_add_event").modal('hide');
		}

		if(jQuery("#kt_modal_edit_event").length) {
			jQuery("#kt_modal_edit_event").modal('hide');
		}

		window.contactDrawer.hide();
		window.currentContactID = id;
		
		$.ajax({
			type: "GET",
			url: "/contacts/getview/id/" + id,
			success: function (data) {
				$("#contact_profile_contents").html(data);
				window.showContactTab(new Event('click'), window.activeContactTab);

				if(!window.scrollToTop) {
					let scrollableDiv = jQuery("#contact_profile_contents"); 
					scrollableDiv.scrollTop(2000);
					window.scrollToTop = true;
				}
			},
			error: function (data, textStatus, errorThrown) {
				window.contactDrawer.hide();
				Swal.fire({
					text: "This contact no longer exists.",
					icon: "error",
					buttonsStyling: false,
					confirmButtonText: "Ok",
					customClass: {
						confirmButton: "btn fw-bold btn-darkblue",
					}
				});
			},
		});
		
		window.contactDrawer.show();
	}

	$(".contact_profile_close_button").on("click", function() {
		window.contactDrawer.hide();
	});


	window.showContactTab = function(event, tab) {
		event.preventDefault();
		$(".contactviewnav").removeClass("active");
		$("#contact_tab_contact_"+tab).addClass("active");
		window.activeContactTab = tab;
		$(".contact_tab").addClass("hidden");
		$("#contact_tab_"+tab).removeClass("hidden");
	}

	window.contactSettingErrors = [];

	window.addContactSettingError = function(error) {
		if(!window.contactSettingErrors.includes(error)) {
			window.contactSettingErrors.push(error);
		}
	}

	window.removeContactSettingError = function(error) {
		if(window.contactSettingErrors.includes(error)) {
			window.contactSettingErrors = window.contactSettingErrors.filter(function(item) {
				return item !== error;
			});
		}
	}

	jQuery("#contact_profile_save").on('click', function(event) {
		event.preventDefault();

		if(window.contactSettingErrors.length == 0) {
			let formData = jQuery("#kt_account_profile_details_form").serialize();
			jQuery.ajax({
				url: jQuery("#kt_account_profile_details_form").attr('action'),
				type: jQuery("#kt_account_profile_details_form").attr('method'),
				data: formData,
				success: function(response) {

					let newFormData = jQuery("#contact_tab_match_form").serialize();

					jQuery.ajax({
						type: jQuery("#contact_tab_match_form").attr('method'),
						url: jQuery("#contact_tab_match_form").attr('action'),
						data: newFormData,
						success: function (data) {
							window.scrollToTop = false;
							window.viewContact(new Event('click'), window.currentContactID);
							window.toastSuccess("Contact Updated!");

							$.each($.fn.dataTable.tables(), function() {
								$(this).DataTable().draw();
							});
						}
					});
				
				},
				error: function(xhr, status, error) {
					console.error('Error submitting form:', error);
				}
			});
		}
	});

	window.setContactOwner = function(contactID, ownerID) {
		var csrf_token = $('meta[name="csrf-token"]').attr('content');
		$.ajax({
			type: "POST",
			url: "/contacts/update_assigned_to",
			data: { 
				_token: csrf_token,
				contact_id: contactID,
				assigned_user_id: ownerID,
			},
			success: function (data) {
				window.viewContact(new Event('click'), contactID);
				window.toastSuccess("Added referral to contact!");
			}
		});
	}

	window.addReferralToContact = function(contactID, referralID) {
		var csrf_token = $('meta[name="csrf-token"]').attr('content');
		$.ajax({
			type: "POST",
			url: "/contacts/referral/add",
			data: { 
				_token: csrf_token,
				contact_id: contactID,
				referral_id: referralID,
			},
			success: function (data) {
				window.viewContact(new Event('click'), contactID);
				window.toastSuccess("Added referral to contact!");
			}
		});
	}

	window.removeReferralFromContact = function(contactID, referralID) {
		var csrf_token = $('meta[name="csrf-token"]').attr('content');
		$.ajax({
			type: "POST",
			url: "/contacts/referral/destroy",
			data: { 
				_token: csrf_token,
				contact_id: contactID,
				referral_id: referralID,
			},
			success: function (data) {
				window.viewContact(new Event('click'), contactID);
				window.toastSuccess("Removed referral from contact!");
			}
		});
	}

	window.setContactLeadStatus = function(contactID, status) {
		var csrf_token = $('meta[name="csrf-token"]').attr('content');
		$.ajax({
			type: "POST",
			url: "/contacts/status/set",
			data: { 
				_token: csrf_token,
				contact_id: contactID,
				lead_status_id: status,
			},
			success: function (data) {
				window.viewContact(new Event('click'), contactID);
				window.toastUpdateContactSuccess("Contact status has been updated!");
			}
		});
	}

	jQuery("#followUpCurrentContract").on("click", function() {
		$("#kt_modal_add_event").modal('show');
		jQuery("#select_contact_container").show();
		var csrf_token = $('meta[name="csrf-token"]').attr('content');

		//jQuery("#follow_up_type").val(type);
		jQuery("#follow_up_contact_id").val(window.currentContactID);

		$.ajax({
			type: "POST",
			url: "/callfollowup/details",
			data : { 
				_token: csrf_token, 
				contact_id: window.currentContactID,
			},
			success: function (data) {

				jQuery("#contact_name").html("<a href='#' onClick='window.viewContact(event, " + data.id + ")'>" + data.first_name + ' ' + data.last_name + "</a>");
				jQuery("#contact_address").html(data.street + ' ' + data.city + ', ' + data.state + ' ' + data.zip);
				jQuery("#contact_type").html(data.type);

				if(data.phone) {
					jQuery("#contact_phone").html("<a href='tel:" + data.phone + "'>" + data.phone + "</a>");
				} else {
					jQuery("#contact_phone").hide();
				}
				if(data.email) {
					jQuery("#contact_email").html("<a href='mailto:" + data.email + "'>" + data.email + "</a>");
					jQuery("#compose_to").val(data.email);
				} else {
					jQuery("#contact_email").hide();
				}

				jQuery("#contact_note").html(data.note);
				jQuery("#contact_note_date").html(data.note_date);
				jQuery("#follow_up_date").val();

				jQuery("#select_contact_container").hide();
			},
		});
	});

	jQuery("#deleteCurrentContact").on("click", function() {
		Swal.fire({
			text: "Are you sure you want to delete this Contact?",
			icon: "warning",
			showCancelButton: true,
			buttonsStyling: false,
			confirmButtonText: "Yes",
			cancelButtonText: "No",
			reverseButtons: true,
			customClass: {
				confirmButton: "btn fw-bold btn-red",
				cancelButton: "btn fw-bold btn-gray"
			}
		}).then(function (result) {
			if (result.value) {
				
				var theUrl = "/contacts/destroy/id/" + window.currentContactID;
				var csrf_token = $('meta[name="csrf-token"]').attr('content');
				$.ajax({
					type: "POST",
					url: theUrl,
					data: { _token: csrf_token },
					success: function (data) {
						Livewire.dispatch('refreshContactGroupCount');

						window.toastSuccess("You have deleted the contact!");

						if (window.contactsDataTable) {
							const thePage = window.contactsDataTable.page();
							window.contactsDataTable.draw();
							window.contactsDataTable.page(thePage);
						}
						window.contactDrawer.hide();
						window.currentContactID = 0;
					},
					error: function (data, textStatus, errorThrown) {
						Swal.fire({
							text: "An error occurred. please try again.",
							icon: "error",
							buttonsStyling: false,
							confirmButtonText: "Ok",
							customClass: {
								confirmButton: "btn fw-bold btn-darkblue",
							}
						});
					},
				});

			} else if (result.dismiss === 'cancel') {
				Swal.fire({
					text: "The contact was not deleted.",
					icon: "error",
					buttonsStyling: false,
					confirmButtonText: "Ok",
					customClass: {
						confirmButton: "btn fw-bold btn-darkblue",
					}
				});
			}
		});
	});

	window.initLeadStatusColorPickers = function() {
		$(".contactLeadStatusPicker").each(function () {
			var $this = $(this); // Current div
			var thisID = $this.attr("id").replace("addColorPicker", "");
			var initialColor = jQuery("#kt_modal_statuses_add_html_color" + thisID).val();
				$this.colorPick({
				'initialColor': initialColor,
				'paletteLabel': '',
				'allowRecent': false,
				'palette': [
					"#C6B656", "#EB69C0", "#774085", "#669CF5", "#82ADC9", "#795548", 
					"#AEBEE2", "#FD58B7", "#C7B455", "#D22C71", "#7054CB", "#2D518D", 
					"#80CAFA", "#333333", "#B8AAF3", "#FB2400", "#5CC57B", "#CE414C", 
					"#9155D4", "#545BD9", "#72C9C5", "#777777", "#356FD9", "#CF0DFF", 
					"#387B51", "#EE7F79", "#EDA7EC", "#381F8E", "#367DB0", "#9DADBA", 
					"#41A33D", "#F4D095"
				],
				'onColorSelected': function () {
					this.element.css({ 'backgroundColor': this.color, 'color': this.color });
					jQuery("#kt_modal_statuses_add_html_color" + thisID).val(this.color);
				}
			});
		});
	}

	$("#kt_modal_edit_lead_statuses").on("show.bs.modal", function() {
		window.initLeadStatusColorPickers();
	});

	$("#kt_modal_edit_lead_statuses_cancel").on("click", function() {
		$("#kt_modal_edit_lead_statuses").modal('hide');
	});

    $("#kt_modal_edit_lead_statuses_submit").on("click", function(event) {
        event.preventDefault(); // Prevent any default behavior

        // Serialize the form data
        var formData = $("#editLeadStatusForm").serialize();
		let loaderOverlay = $('#status-conatact-loader-overlay');
		let loader = $('#status-conatact-loader');

		loaderOverlay.show();
		loader.show();

        // Submit the form via AJAX
        $.ajax({
            url: $("#editLeadStatusForm").attr("action"), // Form's action URL
            method: $("#editLeadStatusForm").attr("method") || "POST", // Form's method (default to POST)
            data: formData,
            success: function(response) {
				$.ajax({
					type: "GET",
					url: "/contacts/getleadstatuses",
					success: function (data) {
						$(".leadStatusDynamicDiv").html(data);
						window.initLeadStatusColorPickers();
						if(window.currentContactID > 0) {
							window.viewContact(new Event('click'), window.currentContactID);
						}
						window.toastSuccess("Lead Statuses Updated!");
						$("#kt_modal_edit_lead_statuses").modal('hide');

						setTimeout(() => {
							loaderOverlay.hide();
							loader.hide();
						}, 200);
					}
				});

            },
            error: function(xhr, status, error) {
                // Handle error response
                console.error("Error submitting form:", error);
                alert("An error occurred while submitting the form.");

				setTimeout(() => {
					loaderOverlay.hide();
					loader.hide();
				}, 200);
            }
        });
    });
	window.closeNewDealModal = function() {
		$('#kt_modal_create_deal').modal('hide');		
	}

	window.viewDealEmbedFile = function(id) {
		$("#preview_file_iframe").attr("src", "/getfileembed/id/" + id);
		$("#kt_modal_view_file").modal("show");
	}

	window.doClaimContact = function(contactID) {
		$.ajax({
			type: "GET",
			url: "/contacts/claim/id/" + contactID,
			success: function (data) {
				window.viewContact(new Event('click'), contactID);
				window.toastSuccess("Contact claimed!");
			}
		});
	}

	document.addEventListener('dealOwnerUpdated', event => {
		window.toastSuccess("Deal owner updated!");
	});

	document.addEventListener('portfolioOwnerUpdated', event => {
		window.toastSuccess("Portfolio owner updated!");
	});
});

window.decodeHtml = function(html) {
	var txt = document.createElement('textarea');
	txt.innerHTML = html;
	return txt.value;
}

let scheduleDate = $('#schedule-date');

scheduleDate.on("click", function(){
	if(scheduleDate.val()) {
		$('.set_schedule_btn_confirm').disabled = false;
	} else {
		$('.set_schedule_btn_confirm').disabled = true;
	}
});

$('.set_schedule_btn').on('click', function(e){
	$(scheduleDate).flatpickr({
		enableTime: false,
		dateFormat: "m/d/Y",
	});

	$('.set_schedule_btn_container').hide();
	$('.set_schedule_content').show();	
});

$('.cancel_schedule_btn').on('click', function(e){
	scheduleDate.val('');
	$('.set_schedule_btn_container').show();
	$('.set_schedule_content').hide();
	
});

$('.remove_schedule_btn').on('click', function(e){
	scheduleDate.val('');
	$('.set_schedule_btn_container').show();
	$('.set_schedule_content').hide();
	$('.set_schedule_values_container').hide();
	
});

$('.edit_schedule_btn').on('click', function(e){
	$('.set_schedule_content').show();
	$('.set_schedule_values_container').hide();
	
});

$('.set_schedule_btn_confirm').on('click', function(e){
	if (!scheduleDate.val()) {

		$(".set_schedule_date_email_error").show();

		return false;

	} else {
		jQuery(".set_schedule_date_email_error").hide();
		$('.set_schedule_values_container').show();
		$('.set_schedule_content').hide();
		$('#set-date').html(scheduleDate.val());
		$('#set-time').html($('#schedule-hour').val() + ':' + $('#schedule-min').val());
	}
});

